import PropTypes from "prop-types";

export default {
  id: PropTypes.number.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  is_manager: PropTypes.bool.isRequired,
  picture_irl: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/support/userShape.js